module.exports = __webpack_public_path__ + "static/media/about-us-background.db46058e.png";